import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  styled,
} from '@mui/material';

const annuaires = [
  {
    title: "Annuaire des statistiques environnementales",
    link: "/annuaireStatistiquesEnvironnementales",
    description: "Explorez les données actualisées sur l'environnement au Burundi, incluant la biodiversité, les ressources naturelles et bien plus encore."
  },
  {
    title: "Parc automobile",
    link: "/parcAutomobile",
    description: "Accédez aux statistiques concernant les véhicules enregistrés et leur impact sur la mobilité et l'environnement."
  },
  {
    title: "Annuaire du commerce extérieur",
    link: "/annuaireCommerceExterieur",
    description: "Analysez les échanges commerciaux internationaux du Burundi, y compris les exportations et les importations."
  },
  {
    title: "Annuaire des statistiques agricoles",
    link: "/annuaireStatistiquesAgricoles",
    description: "Découvrez les données sur la production agricole, les revenus des agriculteurs et l'évolution du secteur agricole."
  },
  {
    title: " Bulletin Conjoncturel des Statistiques aux Frontières",
    link: "/annuaireBulletinConjoncturel",
    description: "Consultez les rapports conjoncturels pour obtenir un aperçu des tendances économiques récentes."
  },
  {
    title: "Annuaire des statistiques sur le tourisme",
    link: "/annuaireStatistiqueTourisme",
    description: "Explorez les données sur le tourisme au Burundi, incluant le flux de touristes et l'impact économique du secteur."
  },
  {
    title: "Annuaire statistique",
    link: "/annuaireStatistique",
    description: "Accédez à une collection exhaustive de statistiques couvrant divers domaines, permettant d'orienter les décisions politiques et économiques."
  },
];

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  transition: 'transform 0.2s ease-in-out',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: `0px 4px 10px rgba(0, 0, 0, 0.1)`
  },
}));

const StyledCardActionArea = styled(CardActionArea)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(2),
  '&:last-child': {
    paddingBottom: theme.spacing(2),
  },
}));

const TitleTypography = styled(Typography)(({ theme }) => ({
  color: '#388E3C', 
  fontWeight: 'bold',
  marginBottom: theme.spacing(1),
}));

const DescriptionTypography = styled(Typography)(({ theme }) => ({
  color: '#555',
}));

function Annuaires() {
  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '20px' }}>
      <NavigationBar />
      <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C' }}>
          Annuaires Statistiques
        </Typography>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          Les annuaires statistiques sont des compilations annuelles fournissant des données actualisées sur divers domaines de la vie économique et sociale. Ce sont des outils essentiels pour les chercheurs, les décideurs et toute personne intéressée par l'analyse des tendances au Burundi.
        </Typography>

        <Grid container spacing={1} style={{ marginTop: '10px' }}>
          {annuaires.map((annuaire, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <StyledCard>
                <StyledCardActionArea href={annuaire.link}  rel="noopener noreferrer">
                  <StyledCardContent>
                    <TitleTypography variant="h6" component="div">
                      {annuaire.title}
                    </TitleTypography>
                    <DescriptionTypography variant="body2">
                      {annuaire.description}
                    </DescriptionTypography>
                  </StyledCardContent>
                </StyledCardActionArea>
              </StyledCard>
            </Grid>
          ))}
        </Grid>
      </Container>
      <br />
      <br />
      <Footer />
    </div>
  );
}

export default Annuaires;